import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitHelloPage } from './init-hello';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitHelloPage,
  ],
  imports: [
    IonicPageModule.forChild(InitHelloPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitHelloPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-hello/init-hello.module.ts